import Core from '@/core/module';
import _ from 'lodash';

export default class Addtocart extends Core {
    init() {
        this.addEventListeners();
        this.loading = false;
    }

    addEventListeners() {
        this.$el.on('change', '.tools select, .tools input', (e) => {
            this.checkQuantity($(e.currentTarget));
        });

        this.$el.on('click', '[name="update_cart"], [checkout]', (e) => {
        	if(this.$el.hasClass('cart--disable-buttons')) {
        		e.preventDefault();
        	}
        });

        this.$el.on('click', '[round-that]', (e) => {
            e.preventDefault();

            const $el = $(e.currentTarget);
            const $container = $el.closest('.tools');
            const $quantity = $container.find('.cart__quantity input');

            const fieldParameters = {
                min: getNumber($quantity.attr('min'), 0),
                max: getNumber($quantity.attr('max'), 0),
                step: getNumber($quantity.attr('step'), 0),
                quantity: getNumber($quantity.val(), 0)
            };

            let roundedValue = getNumber(Math.ceil(fieldParameters.quantity / fieldParameters.step) * fieldParameters.step, 0);

            if(roundedValue < fieldParameters.min) {
            	roundedValue = fieldParameters.min;
            }

            $quantity.val(roundedValue).trigger('change');
        });
    }

    checkQuantity($el) {
    	if(this.loading == true) {
    		return;
    	}

	    const $quantities = this.$el.find('.cart__quantity input');
	    let somethingHasAnError = false;

	    _.each($quantities, (quantity) => {
	    	const $quantity = $(quantity);

	    	let hasErrors = false;

	    	const fieldParameters = {
	    	    min: getNumber($quantity.attr('min'), 0),
	    	    max: getNumber($quantity.attr('max'), 0),
	    	    step: getNumber($quantity.attr('step'), 0),
	    	    quantity: getNumber($quantity.val(), 0)
	    	};

	    	const $errorUl = $quantity.closest('.tools').find(`.form__errors`).hide();
	    	$errorUl.empty();

	    	if(fieldParameters.quantity < fieldParameters.min) {
	    	    $errorUl.append(`<li data-inputname="order">De minimale orderhoeveelheid is ${fieldParameters.min} stuks<br /><a href="#" class="inline-link" round-that><span>aantal verhogen</span> <i class="icon-arrow-right"></i></a></li>`);
	    	    hasErrors = true;
	    	}

	    	else if(fieldParameters.quantity > fieldParameters.max && fieldParameters.max != 0 && fieldParameters.max > fieldParameters.min) {
	    	    $errorUl.append(`<li data-inputname="order">De maximale orderhoeveelheid is ${fieldParameters.max} stuks</li>`);
	    	    hasErrors = true;
	    	}

	    	else if(fieldParameters.quantity / fieldParameters.step != Math.round(fieldParameters.quantity / fieldParameters.step)) {
	    	    $errorUl.append(`<li data-inputname="order">Dit product wordt alleen geleverd per ${fieldParameters.step} stuks <br /><a href="#" class="inline-link" round-that><span>afronden naar boven</span> <i class="icon-arrow-right"></i></a></li>`);
	    	    hasErrors = true;
	    	}

	    	if(hasErrors) {
	    		somethingHasAnError = true;
	    	    $errorUl.show();
	    	    return;
	    	}
	    });

    	this.$el.toggleClass('cart--disable-buttons', somethingHasAnError);

    	if(!somethingHasAnError) {
    		this.loading = true;

    		$('.cart').addClass('cart--loading');

    		const cartData = this.$el.find('form').serializeObject();
    		cartData.update_cart = true;

    		$.ajax({
    			data: cartData,
    			method: 'post',
    			dataType: 'html',
    			url: this.$el.find('form').attr('action'),
    			success: (data) => {
    				const $html = $(`<div>${data}</div>`);
    				$('.cart').removeClass('cart--loading');

    				const $cart = $html.find('.cart');

    				$('.cart').html($cart.html());
    				$('.cart select').customselect();

    				this.loading = false;
    			}
    		})
    	}
    }
}

function getNumber(number, defaultNumber) {
    return isNaN(parseInt(number, 10)) ? defaultNumber : parseInt(number, 10);
}

$.fn.serializeObject = function()
{
   var o = {};
   var a = this.serializeArray();
   $.each(a, function() {
       if (o[this.name]) {
           if (!o[this.name].push) {
               o[this.name] = [o[this.name]];
           }
           o[this.name].push(this.value || '');
       } else {
           o[this.name] = this.value || '';
       }
   });
   return o;
};